import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type SubheadingProps = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
};

export const Subheading: React.FC<SubheadingProps> = ({
  children,
  weight = 'regular',
  style,
  ...props
}) => {
  return (
    <RNText style={[s.common, s.subheading, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
